import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThousandsSeparatorPipe } from './pipes/thousands-separator.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[
    ThousandsSeparatorPipe
  ],
  declarations: [
    ThousandsSeparatorPipe
  ]
})
export class ApplicationPipesModuleModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/application-pipes-module/application-pipes-module.module.ts